import React, { useEffect, useState } from "react";
import "./style.scss";
import { Col, Row } from "antd";
import Navbar from "../navbar";
import CartCounter from "../cartCouter";
import ButtonComponent from "../button";
import { useLocation, useNavigate } from "react-router-dom";
import { HeaderContent } from "../../pagesContent/headerContent";

export default function Header({ cartItems }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleOnclick = () => {
    navigate("/order");
  };

  return (
    <div
      className="header"
      style={{
        backgroundColor: isScrolled
          ? "#3e7e00"
          : location.pathname === "/"
          ? "transparent"
          : "#3e7e00",
      }}
    >
      <Row>
        <Col xs={18} lg={2}>
          <div className="logo">
            <img alt="" src={HeaderContent.logo} />
          </div>
        </Col>
        <Col xs={4} lg={16}>
          <div className="navbar">
            <Navbar />
          </div>
        </Col>
        <Col xs={2} lg={6}>
          <div className="rightNavbar">
            <div className="rightCol">
              {/* <ButtonComponent
                type="link"
                text={HeaderContent.buttonText}
                className="orderNowBtn"
                handleOnclick={handleOnclick}
              /> */}
            </div>

            {/* <CartCounter cartItems={cartItems} /> */}
          </div>
        </Col>
      </Row>
    </div>
  );
}
